// Helpers for consistent ordering of catalog entities.

// Preferred category display order (by slug). Unknown categories
// are placed after these, sorted alphabetically.
const CATEGORY_ORDER = [
  'alimentos',
  'cuidado-personal',
  'hogar',
  'licores-bebidas',
];

export const sortCategories = (categories = []) => {
  const arr = [...categories];
  arr.sort((a, b) => {
    const ia = CATEGORY_ORDER.indexOf((a.slug || '').toLowerCase());
    const ib = CATEGORY_ORDER.indexOf((b.slug || '').toLowerCase());
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;
    return (a.name || '').localeCompare(b.name || '', 'es');
  });
  return arr;
};

// Group items by brand name preserving alphabetical order
export const groupByBrand = (items = []) => {
  const groups = {};
  items.forEach(item => {
    const key = item.brand || 'Sin marca';
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
  });
  return Object.keys(groups)
    .sort((a, b) => a.localeCompare(b, 'es'))
    .map(brand => ({
      brand,
      brandId: groups[brand][0]?.brandId || null,
      items: [...groups[brand]].sort((x, y) =>
        (x.name || '').localeCompare(y.name || '', 'es')
      ),
    }));
};
